// import { useState, useEffect, useCallback } from 'react';
// import { useAuth } from "../../context/AuthProvider";
// import { useParams, useNavigate, Link } from "react-router-dom";
// import { toast } from 'sonner';
// import Loading from '../../cors/Loading';
// import ProductImageGallery from "../../components/ProductImageGallery";
// import VariantSelector from "../../components/VariantSelector";
// import OrderModal from '../../cors/OrderModal'; 
// import { BASE_URL } from '../../apiConfig';
// import Cookies from 'js-cookie';
// import { ShoppingCart, Tag, Package, Percent } from 'lucide-react';
// import { useLanguage } from "../../context/LanguageProvider";

// export default function ProductDetail() {
//   const { token, role } = useAuth();
//   const { t } = useLanguage();
//   const { id } = useParams();
//   const router = useNavigate();
//   const [product, setProduct] = useState(null);
//   const [quantity, setQuantity] = useState(1);
//   const [selectedVariants, setSelectedVariants] = useState([]); 
//   const [isModalOpenOrder, setIsModalOpenOrder] = useState(false); 
//   const [loading, setLoading] = useState(true);
//   const [error, setError] = useState(null);

//   const fetchProduct = useCallback(async () => {
//     if (!id) {
//       setError(t('products.id_missing'));
//       setLoading(false);
//       return;
//     }

//     setLoading(true);
//     setError(null);
//     try {
//       if (!token) {
//         toast.error(t('errors.auth_token_missing'));
//         router('/login');
//         setLoading(false);
//         return;
//       }

//       const res = await fetch(`${BASE_URL}/api/products/${id}`, {
//         method: "GET",
//         headers: {
//           "Content-Type": "application/json",
//           "Authorization": `Bearer ${token}`,
//         },
//       });

//       if (!res.ok) {
//         const errorData = await res.json();
//         const errorMessage = errorData.message || `${t('products.fetch_failed')}: ${res.statusText}`;
//         throw new Error(errorMessage);
//       }

//       const data = await res.json();
//       if (data.status === true && data.data) {
//         setProduct(data.data);
//         setSelectedVariants([{}]);
//       } else {
//         throw new Error(data.message || t('products.unexpected_format'));
//       }
//     } catch (err) {
//       console.error("Error fetching product:", err);
//       setError(err.message || t('products.loading_error'));
//       toast.error(`${t('messages.error')}: ${err.message || t('products.loading_error')}`);
//     } finally {
//       setLoading(false);
//     }
//   }, [id, token, router, t]);



//   useEffect(() => {
//     fetchProduct();
//   }, [fetchProduct]);

//   useEffect(() => {
//     if (quantity > selectedVariants.length) {
//       const newVariants = [...selectedVariants];
//       while (newVariants.length < quantity) {
//         newVariants.push({});
//       }
//       setSelectedVariants(newVariants);
//     } else if (quantity < selectedVariants.length) {
//       setSelectedVariants(selectedVariants.slice(0, quantity));
//     }
//   }, [quantity]);

//   const handleVariantChange = (variants, index) => {
//     const newSelectedVariants = [...selectedVariants];
//     newSelectedVariants[index] = variants;
//     setSelectedVariants(newSelectedVariants);
//   };

// const handleAddToCart = () => {
//   if (!product) return;

//   if (product?.variants?.length > 0) {
//     const requiredVariantTypes = Array.from(
//       new Set(
//         product.variants.flatMap(group => 
//           group.details.map(detail => detail.variant.type)
//         )
//       )
//     );

//     for (let i = 0; i < quantity; i++) {
//       const missingTypes = requiredVariantTypes.filter(
//         type => !selectedVariants[i]?.[type]
//       );

//       if (missingTypes.length > 0) {
//         const missingTypesText = missingTypes.map(t => `"${t}"`).join(', ');
//         toast.error(
//           `${t('products.unit')} ${i + 1}: ${t('products.select_required_variants')} ${missingTypesText}`,
//           { duration: 5000 }
//         );
        
//         missingTypes.forEach(type => {
//           const element = document.querySelector(`[data-variant-type="${type}-${i}"]`);
//           element?.classList.add('animate-pulse', 'ring-2', 'ring-red-500');
//           setTimeout(() => {
//             element?.classList.remove('animate-pulse', 'ring-2', 'ring-red-500');
//           }, 3000);
//         });
//         return;
//       }

//       const isValidCombination = product.variants.some(group =>
//         group.details.every(detail =>
//           selectedVariants[i][detail.variant.type]?.id === detail.variant.id
//         )
//       );

//       if (!isValidCombination) {
//         toast.error(`${t('products.unit')} ${i + 1}: ${t('products.variant_not_available')}`, { duration: 5000 });
//         return;
//       }
//     }
//   }

//   const cartKey = "cart";
//   const existingCart = JSON.parse(Cookies.get(cartKey) || "[]");

//   if (!product?.variants?.length) {
//     const existingIndex = existingCart.findIndex(item => item.productId === product.id);
    
//     if (existingIndex !== -1) {
//       existingCart[existingIndex].quantity += quantity;
//     } else {
//       existingCart.push({
//         key: `${product.id}`,
//         productId: product.id,
//         name: product.name,
//         quantity,
//         price: isDiscounted ? discountedPrice : originalPrice,
//         sellingPrice: product.price?.selling_price,
//         selectedVariants: {},
//         image: product.image_py || (product.images?.[0]?.image || null),
//       });
//     }
//   } 
//   // For products with variants
//   else {
//     // Group selected variants by their combination
//     const variantGroups = {};
    
//     selectedVariants.forEach(variants => {
//       const variantKey = Object.keys(variants)
//         .sort()
//         .map(type => `${type}:${variants[type].id}`)
//         .join('|');
      
//       if (!variantGroups[variantKey]) {
//         variantGroups[variantKey] = {
//           variants,
//           count: 0
//         };
//       }
//       variantGroups[variantKey].count++;
//     });

//     // Process each variant group
//     Object.entries(variantGroups).forEach(([variantKey, { variants, count }]) => {
//       const cartItemKey = `${product.id}-${variantKey}`;
//       const existingIndex = existingCart.findIndex(item => item.key === cartItemKey);

//       if (existingIndex !== -1) {
//         // If this variant combination already exists, just increase its quantity
//         existingCart[existingIndex].quantity += count;
//       } else {
//         // Otherwise add new item with this variant combination
//         existingCart.push({
//           key: cartItemKey,
//           productId: product.id,
//           name: product.name,
//           quantity: count,
//           price: isDiscounted ? discountedPrice : originalPrice,
//           sellingPrice: product.price?.selling_price,
//           selectedVariants: variants,
//           image: product.image_py || (product.images?.[0]?.image || null),
//         });
//       }
//     });
//   }

//   const expires = new Date();
//   expires.setMinutes(expires.getMinutes() + 70); 

//   Cookies.set(cartKey, JSON.stringify(existingCart), { 
//     expires: expires,
//     path: '/',
//   });
  
//   toast.success(`${quantity} x ${product.name} ${t('products.added_to_cart')}`);
// };

//   if (loading) {
//     return <div className='flex justify-center my-72'><Loading /></div>;
//   }

//   if (error) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
//         <div className="max-w-md w-full space-y-8 text-center">
//           <h2 className="mt-6 text-3xl font-extrabold text-red-600">{t('messages.error')}</h2>
//           <p className="mt-2 text-sm text-gray-600">{error}</p>
//           <button
//             onClick={() => fetchProduct()}
//             className="mt-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-[var(--color-primary-500)] hover:bg-[#089c87] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[var(--color-primary-500)]"
//           >
//             {t('common.retry')}
//           </button>
//           <button
//             onClick={() => router("/dashboard")}
//             className="ml-4 mt-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-[var(--color-primary-500)] bg-white border-[var(--color-primary-500)] hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[var(--color-primary-500)]"
//           >
//             {t('buttons.back')}
//           </button>
//         </div>
//       </div>
//     );
//   }

//   if (!product) {
//     return (
//       <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
//         <div className="max-w-md w-full space-y-8 text-center">
//           <h2 className="mt-6 text-3xl font-extrabold text-gray-900">{t('products.not_found')}</h2>
//           <p className="mt-2 text-sm text-gray-600">{t('products.not_found_public')}</p>
//           <button
//             onClick={() => router('/products')}
//             className="mt-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-[var(--color-primary-500)] hover:bg-[#089c87] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[var(--color-primary-500)]"
//           >
//             {t('products.browse_other')}
//           </button>
//         </div>
//       </div>
//     );
//   }

//   const originalPrice = parseFloat(product.price?.saller_price || 0);
//   const now = new Date();
//   const isDiscounted = product.discount && 
//                       product.discount.status === true && // status should be boolean true
//                       new Date(product.discount.date_start) <= now && 
//                       new Date(product.discount.date_end) >= now;

//   const discountedPrice = isDiscounted
//     ? originalPrice - (originalPrice * (product.discount.value || 0)) / 100
//     : originalPrice;

//   return (
//     <div className="min-h-screen bg-gray-50 py-8">
//       <div className="mx-auto max-w-7xl px-4 sm:px-6 lg:px-8">
//         <div className="grid grid-cols-1 gap-8 lg:grid-cols-2 lg:gap-16">
//           <div className="lg:sticky lg:top-8">
//             <ProductImageGallery
//               images={[
//                 ...(product.image_py ? [{ id: -1, product_id: product.id, image: product.image_py }] : []),
//                 ...(product.images || [])
//               ]}
//               productName={product.name}
//             />
//           </div>

//           <div className="space-y-6">
//             <div>
//               <div className="mb-2 flex items-center space-x-2">
//                 {product.category?.title && (
//                   <span className="rounded-full bg-[var(--color-primary-50)] px-3 py-1 text-xs font-medium text-[var(--color-primary-500)]">
//                     {product.category.title}
//                   </span>
//                 )}
//                 {product.status === "active" ? (
//                   <span className="rounded-full bg-green-100 px-3 py-1 text-xs font-medium text-green-800">
//                     {t('products.in_stock')}
//                   </span>
//                 ) : (
//                   <span className="rounded-full bg-red-100 px-3 py-1 text-xs font-medium text-red-800">
//                     {t('products.out_of_stock')}
//                   </span>
//                 )}
//                 {product.product_expired_soon === true && (
//                   <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-[10px] font-semibold">{t('products.limited_stock')}</span>
//                 )}
//               </div>
//               <h1 className="text-3xl font-bold text-gray-900 sm:text-3xl mt-5">{product.name}</h1>
//               <div className='flex items-center text-sm gap-1'>
//                 {[...Array(5)].map((_, i) => (
//                   <span key={i} className={i < product.rating ? 'text-yellow-500 text-lg' : 'text-gray-300 text-lg'}>
//                     ★
//                   </span>
//                 ))}
//                 ({product.rating}/5)
//               </div>
//               <div className='text-gray-500 text-xs'>{t('products.product_id')} : {product.id}</div>
//             </div>

//             <div className="border-b border-gray-200 pb-8">
//               <div className="flex itmes-end gap-3">
//                 <span className="text-2xl font-bold text-green-600">{discountedPrice.toFixed(2)}MAD</span>
//                 {isDiscounted && (
//                   <div className='flex items-center gap-2 '>
//                     <span className="text-gray-500 line-through">{originalPrice.toFixed(2)}MAD</span>
//                     <span className="rounded-lg bg-red-100 px-3 py-1 text-xs font-medium text-red-800">
//                       -{product.discount.value || 0}% {t('products.off')}
//                     </span>
//                   </div>
//                 )}
//               </div>

//               {isDiscounted && product.discount?.date_end && (
//                 <p className="my-2 text-xs text-gray-600">
//                   {t('products.offer_valid_until')} {new Date(product.discount.date_end).toLocaleDateString('en-GB')}
//                 </p>
//               )}
//               <span className="text-sm text-gray-500 mt-4">{t('products.recommended_sale')} : <span className='font-bold'>{product.price?.selling_price}MAD</span></span>
//             </div>

//             {product.description && (
//               <div className="border-b border-gray-200 pb-8">
//                 <h3 className="font-medium text-gray-900 mb-4">{t('forms.labels.description')}</h3>
//                 <p className="text-gray-700 leading-relaxed text-sm">{product.description}</p>
//               </div>
//             )}

//             {product.image_urls && (
//               <div className="border-b border-gray-200 pb-8">
//                 <h3 className="font-medium text-gray-900 mb-1">{t('products.other_images')} : </h3>
//                 <Link
//                   to={product.image_urls}
//                   target="_blank"
//                   rel="noopener noreferrer"
//                   className="text-blue-600 underline text-sm"
//                 >
//                   {product.image_urls}
//                 </Link>
//               </div>
//             )}

//             <div className="space-y-6">
//               <div>
//                 <label htmlFor="quantity" className="text-sm font-medium text-gray-900 mb-3 block">
//                   {t('products.quantity')}
//                 </label>
//                 <div className="flex items-center space-x-4">
//                   <div className="flex items-center border border-gray-300 rounded-lg">
//                     <button
//                       onClick={() => setQuantity(prev => Math.max(1, prev - 1))}
//                       className="p-2 cursor-pointer hover:bg-gray-100 transition-colors duration-200 rounded-l-lg"
//                       disabled={quantity <= 1}
//                     >
//                       <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4" />
//                       </svg>
//                     </button>
//                     <span className="px-4 py-2 text-center min-w-[60px] border-l border-r border-gray-300">
//                       {quantity}
//                     </span>
//                     <button
//                       onClick={() => setQuantity(prev => Math.min(product.price.stock, prev + 1))}
//                       className="p-2 cursor-pointer hover:bg-gray-100 transition-colors duration-200 rounded-r-lg"
//                       disabled={quantity >= (product.price?.stock || 0)}
//                     >
//                       <svg className="h-4 w-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
//                         <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
//                       </svg>
//                     </button>
//                   </div>
//                 </div>
//               </div>

//               {/* Variant selectors for each unit */}
//               {product.variants && product.variants.length > 0 && (
//                 <div className="border-b border-gray-200 pb-8 space-y-4">
//                   <h3 className="font-medium text-gray-900">{t('products.select_variants')}</h3>
//                   {Array.from({ length: quantity }).map((_, index) => (
//                     <div key={index} className="border border-gray-200 rounded-lg px-4 py-2">
//                       <h4 className="font-medium mb-1">{t('products.item')} #{index + 1}</h4>
//                       <VariantSelector
//                         variants={product.variants}
//                         onVariantChange={(variants) => handleVariantChange(variants, index)}
//                         initialSelectedVariants={selectedVariants[index] || {}}
//                         index={index} // Pass index to create unique data attributes
//                       />
//                     </div>
//                   ))}
//                 </div>
//               )}

//               <div className="flex space-x-2">
//                 <button
//                   onClick={() => setIsModalOpenOrder(true)} 
//                   className={`flex-1 text-sm px-8 py-3 rounded-xl font-semibold text-lg transition-colors duration-200 focus:outline-none focus:ring-2 focus:ring-offset-2
//                     ${product.status === 'active' && (product.price?.stock || 0) > 0
//                       ? 'bg-[var(--color-primary-500)] text-white cursor-pointer hover:bg-[var(--color-primary-400)] focus:ring-[var(--color-primary-500)]'
//                       : 'bg-gray-300 text-white cursor-not-allowed focus:ring-gray-300'}
//                   `}
//                   disabled={(product.status !== 'active') || (product.price?.stock || 0) <= 0}
//                 >
//                   {product.status === 'active' && (product.price?.stock || 0) > 0 ? t('products.order_now') : t('products.out_of_stock')}
//                 </button>

//                 <button
//                   onClick={handleAddToCart}
//                   className={`border px-8 py-3 rounded-xl font-semibold text-lg transition-colors duration-200 text-xs
//                     ${product.status === 'active' && (product.price?.stock || 0) > 0
//                       ? 'border-[var(--color-primary-500)] text-[var(--color-primary-500)] hover:bg-[var(--color-primary-500)] hover:text-white cursor-pointer'
//                       : 'border-gray-300 text-gray-400 bg-gray-100 cursor-not-allowed'}
//                   `}
//                   disabled={(product.status !== 'active') || (product.price?.stock || 0) <= 0}
//                 >
//                   {product.status === 'active' && (product.price?.stock || 0) > 0
//                     ? <ShoppingCart size={20} />
//                     : t('products.out_of_stock')}
//                 </button>
//               </div>
//             </div>
//             {
//               role === 1 ?
//                 <div className=" space-y-6">
//                   <div>
//                     <div className='border-t border-gray-200 py-8'>
//                       <h3 className="text-lg font-medium text-gray-900 mb-4">{t('products.details')}</h3>
//                       <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
//                         {product.fournisseur && (
//                           <>
//                             <div>
//                               <span className="font-medium text-gray-900">{t('forms.labels.fournisseur')}:</span>
//                               <span className="ml-2 text-gray-700">{product.fournisseur.name}({product.fournisseur.name_personnel})</span>
//                             </div>
//                             <div>
//                               <span className="font-medium text-gray-900">{t('forms.labels.contact_name')}:</span>
//                               <span className="ml-2 text-gray-700">{product.fournisseur.phone}</span>
//                             </div>
//                           </>
//                         )}
//                         <div>
//                           <span className="font-medium text-gray-900">{t('products.purchase_price')}:</span>
//                           <span className="ml-2 text-gray-700">{product.price.achat_price} MAD</span>
//                         </div>
//                         {product.price?.stock !== undefined && (
//                           <div>
//                             <span className="font-medium text-gray-900">{t('products.stock')}:</span>
//                             <span className="ml-2 text-gray-700">{product.price.stock} {t('products.units')}</span>
//                           </div>
//                         )}
//                       </div>
//                     </div>
//                     <div>
//                       {product.sallers && product.sallers.length > 0 && (
//                         <div className='border-y border-gray-200 py-8'>
//                           <h3 className="text-lg font-medium text-gray-900 mb-4">{t('navbar.sellers')} :</h3>
//                           <div className=" flex items-center gap-3">
//                             {product.sallers.map((saller,id) => (
//                               <label
//                                 key={id}
//                                 className={`max-w-max flex items-center py-1.5 px-2 rounded-full cursor-pointer transition-all duration-200 ${
//                                   "bg-[var(--color-primary-50)] border-2 border-[var(--color-primary-500)]"
//                                 }`}
//                               >
//                                 <div className="">
//                                   <div className="text-xs font-medium text-[var(--color-primary-500)]">
//                                     {saller.saller_info?.name} {saller.saller_info?.name_store && `(${saller.saller_info.name_store})`}
//                                   </div>
//                                 </div>
//                               </label>
//                             ))}
//                           </div>
//                         </div>
//                       )}
//                     </div>
//                   </div>
//                 </div>
//               :''
//             }
//           </div>
//         </div>
//       </div>
//       {
//         isModalOpenOrder &&
//           <OrderModal
//             isOpen={isModalOpenOrder}
//             onClose={() => setIsModalOpenOrder(false)}
//             product={product}
//           />
//       }
//     </div>
//   );
// }



import { useState, useEffect, useCallback } from 'react';
import { useAuth } from "../../context/AuthProvider";
import { useParams, useNavigate, Link } from "react-router-dom";
import { toast } from 'sonner';
import Loading from '../../cors/Loading';
import ProductImageGallery from "../../components/ProductImageGallery";
import VariantSelector from "../../components/VariantSelector";
import OrderModal from '../../cors/OrderModal';
import { BASE_URL } from '../../apiConfig';
import Cookies from 'js-cookie';
import {
  ShoppingCart, Heart, ShoppingBag, Wallet, TrendingUp, Package,
  Truck, CreditCard, RotateCcw, ShieldCheck, Calculator, ChevronRight, Star, Percent
} from 'lucide-react';
import { useLanguage } from "../../context/LanguageProvider";
import DOMPurify from "dompurify";

DOMPurify.addHook("afterSanitizeAttributes", (node) => {
  if (node.tagName === "A" && node.getAttribute("href")) {
    node.setAttribute("target", "_blank")
    node.setAttribute("rel", "noopener noreferrer")
  }
})

export default function ProductDetail() {
  const { token, role } = useAuth();
  const { t } = useLanguage();
  const { id } = useParams();
  const router = useNavigate();
  const [product, setProduct] = useState(null);
  const [quantity, setQuantity] = useState(1);
  const [selectedVariants, setSelectedVariants] = useState([]);
  const [isModalOpenOrder, setIsModalOpenOrder] = useState(false);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [isWishlisted, setIsWishlisted] = useState(false);
  const [activeTab, setActiveTab] = useState('description');

  const fetchProduct = useCallback(async () => {
    if (!id) {
      setError(t('products.id_missing'));
      setLoading(false);
      return;
    }

    setLoading(true);
    setError(null);
    try {
      if (!token) {
        toast.error(t('errors.auth_token_missing'));
        router('/login');
        setLoading(false);
        return;
      }

      const res = await fetch(`${BASE_URL}/api/products/${id}`, {
        method: "GET",
        headers: {
          "Content-Type": "application/json",
          "Authorization": `Bearer ${token}`,
        },
      });

      if (!res.ok) {
        const errorData = await res.json();
        const errorMessage = errorData.message || `${t('products.fetch_failed')}: ${res.statusText}`;
        throw new Error(errorMessage);
      }

      const data = await res.json();
      if (data.status === true && data.data) {
        setProduct(data.data);
        setSelectedVariants([{}]);
      } else {
        throw new Error(data.message || t('products.unexpected_format'));
      }
    } catch (err) {
      console.error("Error fetching product:", err);
      setError(err.message || t('products.loading_error'));
      toast.error(`${t('messages.error')}: ${err.message || t('products.loading_error')}`);
    } finally {
      setLoading(false);
    }
  }, [id, token, router, t]);

  useEffect(() => {
    fetchProduct();
  }, [fetchProduct]);

  useEffect(() => {
    if (quantity > selectedVariants.length) {
      const newVariants = [...selectedVariants];
      while (newVariants.length < quantity) {
        newVariants.push({});
      }
      setSelectedVariants(newVariants);
    } else if (quantity < selectedVariants.length) {
      setSelectedVariants(selectedVariants.slice(0, quantity));
    }
  }, [quantity]);

  const handleVariantChange = (variants, index) => {
    const newSelectedVariants = [...selectedVariants];
    newSelectedVariants[index] = variants;
    setSelectedVariants(newSelectedVariants);
  };

  const handleToggleWishlist = () => {
    setIsWishlisted(prev => !prev);
    toast.success(!isWishlisted ? t('products.added_to_wishlist') || t('products.added_to_cart') : t('products.removed_from_wishlist') || t('messages.success'));
  };

  const handleAddToCart = () => {
    if (!product) return;

    if (product?.variants?.length > 0) {
      const requiredVariantTypes = Array.from(
        new Set(
          product.variants.flatMap(group =>
            group.details.map(detail => detail.variant.type)
          )
        )
      );

      for (let i = 0; i < quantity; i++) {
        const missingTypes = requiredVariantTypes.filter(
          type => !selectedVariants[i]?.[type]
        );

        if (missingTypes.length > 0) {
          const missingTypesText = missingTypes.map(t => `"${t}"`).join(', ');
          toast.error(
            `${t('products.unit')} ${i + 1}: ${t('products.select_required_variants')} ${missingTypesText}`,
            { duration: 5000 }
          );

          missingTypes.forEach(type => {
            const element = document.querySelector(`[data-variant-type="${type}-${i}"]`);
            element?.classList.add('animate-pulse', 'ring-2', 'ring-red-500');
            setTimeout(() => {
              element?.classList.remove('animate-pulse', 'ring-2', 'ring-red-500');
            }, 3000);
          });
          return;
        }

        const isValidCombination = product.variants.some(group =>
          group.details.every(detail =>
            selectedVariants[i][detail.variant.type]?.id === detail.variant.id
          )
        );

        if (!isValidCombination) {
          toast.error(`${t('products.unit')} ${i + 1}: ${t('products.variant_not_available')}`, { duration: 5000 });
          return;
        }
      }
    }

    const cartKey = "cart";
    const existingCart = JSON.parse(Cookies.get(cartKey) || "[]");

    if (!product?.variants?.length) {
      const existingIndex = existingCart.findIndex(item => item.productId === product.id);

      if (existingIndex !== -1) {
        existingCart[existingIndex].quantity += quantity;
      } else {
        existingCart.push({
          key: `${product.id}`,
          productId: product.id,
          name: product.name,
          quantity,
          price: isDiscounted ? discountedPrice : originalPrice,
          sellingPrice: product.price?.selling_price,
          selectedVariants: {},
          image: product.image_py || (product.images?.[0]?.image || null),
        });
      }
    }
    // For products with variants
    else {
      // Group selected variants by their combination
      const variantGroups = {};

      selectedVariants.forEach(variants => {
        const variantKey = Object.keys(variants)
          .sort()
          .map(type => `${type}:${variants[type].id}`)
          .join('|');

        if (!variantGroups[variantKey]) {
          variantGroups[variantKey] = {
            variants,
            count: 0
          };
        }
        variantGroups[variantKey].count++;
      });

      // Process each variant group
      Object.entries(variantGroups).forEach(([variantKey, { variants, count }]) => {
        const cartItemKey = `${product.id}-${variantKey}`;
        const existingIndex = existingCart.findIndex(item => item.key === cartItemKey);

        if (existingIndex !== -1) {
          // If this variant combination already exists, just increase its quantity
          existingCart[existingIndex].quantity += count;
        } else {
          // Otherwise add new item with this variant combination
          existingCart.push({
            key: cartItemKey,
            productId: product.id,
            name: product.name,
            quantity: count,
            price: isDiscounted ? discountedPrice : originalPrice,
            sellingPrice: product.price?.selling_price,
            selectedVariants: variants,
            image: product.image_py || (product.images?.[0]?.image || null),
          });
        }
      });
    }

    const expires = new Date();
    expires.setMinutes(expires.getMinutes() + 70);

    Cookies.set(cartKey, JSON.stringify(existingCart), {
      expires: expires,
      path: '/',
    });

    toast.success(`${quantity} x ${product.name} ${t('products.added_to_cart')}`);
  };

  if (loading) {
    return <ProductDetailSkeleton />;
  }

  if (error) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8 text-center">
          <h2 className="mt-6 text-3xl font-extrabold text-red-600">{t('messages.error')}</h2>
          <p className="mt-2 text-sm text-gray-600">{error}</p>
          <button
            onClick={() => fetchProduct()}
            className="mt-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-[var(--color-primary-500)] hover:bg-[#089c87] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[var(--color-primary-500)]"
          >
            {t('common.retry')}
          </button>
          <button
            onClick={() => router("/dashboard")}
            className="ml-4 mt-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-[var(--color-primary-500)] bg-white border-[var(--color-primary-500)] hover:bg-gray-100 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[var(--color-primary-500)]"
          >
            {t('buttons.back')}
          </button>
        </div>
      </div>
    );
  }

  if (!product) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-gray-50 py-12 px-4 sm:px-6 lg:px-8">
        <div className="max-w-md w-full space-y-8 text-center">
          <h2 className="mt-6 text-3xl font-extrabold text-gray-900">{t('products.not_found')}</h2>
          <p className="mt-2 text-sm text-gray-600">{t('products.not_found_public')}</p>
          <button
            onClick={() => router('/products')}
            className="mt-4 inline-flex items-center px-4 py-2 border border-transparent text-sm font-medium rounded-md shadow-sm text-white bg-[var(--color-primary-500)] hover:bg-[#089c87] focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-[var(--color-primary-500)]"
          >
            {t('products.browse_other')}
          </button>
        </div>
      </div>
    );
  }

  // --- Pricing & profit math -------------------------------------------------
  // originalPrice: seller's base cost before any active discount is applied
  const originalPrice = parseFloat(product.price?.saller_price || 0);
  const now = new Date();
  const isDiscounted = product.discount &&
                      product.discount.status === true &&
                      new Date(product.discount.date_start) <= now &&
                      new Date(product.discount.date_end) >= now;

  // discountedPrice: what the seller actually pays right now ("Prix de vente" / "Prix d'achat")
  const discountedPrice = isDiscounted
    ? originalPrice - (originalPrice * (product.discount.value || 0)) / 100
    : originalPrice;

  // recommendedPrice: the retail price recommended to resell to end customers
  const recommendedPrice = parseFloat(product.price?.selling_price || 0);
  const estimatedProfit = recommendedPrice - discountedPrice;
  const estimatedMargin = discountedPrice > 0 ? (estimatedProfit / discountedPrice) * 100 : 0;

  const reviewsCount = product.reviews_count ?? product.reviews?.length ?? 0;

  const stats = [
    { icon: TrendingUp, color: 'text-purple-500 bg-purple-100', label: t('products.profit_margin') || 'Marge', value: estimatedMargin > 0 ? `${estimatedMargin.toFixed(1)}%` : null },
    { icon: Wallet, color: 'text-green-500 bg-green-100', label: t('products.estimated_profit') || 'Profit estimé', value: estimatedProfit > 0 ? `${estimatedProfit.toFixed(2)} MAD` : null },
    { icon: Package, color: 'text-yellow-500 bg-yellow-100', label: t('products.available_stock') || 'Stock disponible', value: product.price?.stock > 0 ? `${product.price.stock} ${t('products.units')}` : null },
    { icon: Star, color: 'text-orange-500 bg-orange-100', label: t('products.average_rating') || 'Note moyenne', value: product.rating != null ? `${product.rating}/5` : null },
    ...(isDiscounted ? [{ icon: Percent, color: 'text-red-500 bg-red-100', label: t('products.discount') || 'Réduction', value: `-${product.discount.value}%` }] : []),
  ].filter(stat => stat.value !== null);

  const tabs = [
    { key: 'description', label: t('forms.labels.description') || 'Description' },
    { key: 'specifications', label: t('products.specifications') || 'Spécifications' },
    { key: 'reviews', label: `${t('products.reviews') || 'Avis'} (${reviewsCount})` },
    { key: 'shipping', label: t('products.shipping_returns') || 'Livraison & Retours' },
    { key: 'videos', label: t('products.videos') || 'Vidéos' },
  ];

  const infoItems = [
    { icon: Truck, label: t('products.delivery') || 'Livraison', value: '24-48h' },
    { icon: CreditCard, label: t('products.payment') || 'Paiement', value: t('products.cash_on_delivery') || 'À la livraison' },
    // { icon: RotateCcw, label: t('products.returns') || 'Retour', value: `7 ${t('products.days') || 'jours'}` },
    { icon: ShieldCheck, label: t('products.warranty') || 'Garantie', value: t('products.quality') || 'Qualité' },
  ];

  const isAvailable = product.status === 'active' && (product.price?.stock || 0) > 0;

  function ProductDetailSkeleton() {
  return (
    <div className="min-h-screen bg-gray-50 py-8 animate-pulse">
      <div className="mx-auto max-w-8xl px-4 sm:px-6 lg:px-8">
        {/* Breadcrumb */}
        <div className="mb-6 flex items-center gap-2">
          <div className="h-3 w-16 rounded bg-gray-200" />
          <div className="h-3 w-3 rounded bg-gray-200" />
          <div className="h-3 w-24 rounded bg-gray-200" />
        </div>

        <div className="rounded-2xl bg-white p-6 shadow-sm sm:p-8">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-12">
            {/* ---------------- LEFT ---------------- */}
            <div className="space-y-6">
              <div className="lg:hidden">
                <div className="mb-3 flex gap-2">
                  <div className="h-5 w-20 rounded-full bg-gray-200" />
                  <div className="h-5 w-16 rounded-full bg-gray-200" />
                </div>
                <div className="h-7 w-3/4 rounded bg-gray-200" />
                <div className="mt-3 flex items-center gap-2">
                  <div className="h-4 w-24 rounded bg-gray-200" />
                  <div className="h-4 w-32 rounded bg-gray-200" />
                </div>
              </div>
              {/* Gallery */}
              <div className="flex flex-col-reverse items-start gap-4 md:flex-row">
                <div className="flex gap-3 overflow-hidden md:flex-col">
                  {[...Array(5)].map((_, i) => (
                    <div key={i} className="h-16 w-16 flex-shrink-0 rounded-xl bg-gray-200" />
                  ))}
                </div>
                <div className="aspect-square w-full flex-1 rounded-2xl bg-gray-200 md:max-h-[540px]" />
              </div>

              {/* Stats row */}
              <div className="grid grid-cols-2 gap-3 sm:grid-cols-4 lg:grid-cols-4">
                {[...Array(4)].map((_, i) => (
                  <div key={i} className="flex flex-col items-center gap-2 rounded-xl border border-gray-100 bg-gray-50/60 dark:bg-stone-900 px-2 py-4">
                    <div className="h-8 w-8 rounded-full bg-gray-200" />
                    <div className="h-3 w-10 rounded bg-gray-200" />
                    <div className="h-2 w-14 rounded bg-gray-200" />
                  </div>
                ))}
              </div>

              {/* Tabs */}
              <div>
                <div className="flex gap-6 border-b border-gray-200 pb-3">
                  {[...Array(4)].map((_, i) => (
                    <div key={i} className="h-3 w-20 shrink-0 rounded bg-gray-200" />
                  ))}
                </div>
                <div className="space-y-3 py-6">
                  <div className="h-3 w-full rounded bg-gray-200" />
                  <div className="h-3 w-11/12 rounded bg-gray-200" />
                  <div className="h-3 w-4/5 rounded bg-gray-200" />
                  <div className="h-3 w-3/4 rounded bg-gray-200" />
                </div>
              </div>
            </div>

            {/* ---------------- RIGHT ---------------- */}
            <div className="space-y-6">
              {/* Badges + title */}
              <div className="max-lg:hidden">
                <div className="mb-3 flex gap-2">
                  <div className="h-5 w-20 rounded-full bg-gray-200" />
                  <div className="h-5 w-16 rounded-full bg-gray-200" />
                </div>
                <div className="h-7 w-3/4 rounded bg-gray-200" />
                <div className="mt-3 flex items-center gap-2">
                  <div className="h-4 w-24 rounded bg-gray-200" />
                  <div className="h-4 w-32 rounded bg-gray-200" />
                </div>
              </div>

              {/* Price card */}
              <div className="rounded-2xl border border-gray-200 bg-gray-50 p-5">
                <div className="flex flex-wrap items-start justify-between gap-4">
                  <div className="space-y-2">
                    <div className="h-3 w-24 rounded bg-gray-200" />
                    <div className="h-7 w-32 rounded bg-gray-200" />
                    <div className="h-3 w-40 rounded bg-gray-200" />
                  </div>
                  <div className="h-16 w-32 rounded-xl bg-gray-200" />
                </div>
              </div>

              {/* Info icons row */}
              <div className="grid grid-cols-2 gap-3 border-b border-gray-200 pb-6 sm:grid-cols-4">
                {[...Array(4)].map((_, i) => (
                  <div key={i} className="flex items-center gap-2">
                    <div className="h-9 w-9 shrink-0 rounded-full bg-gray-200" />
                    <div className="space-y-1.5">
                      <div className="h-2 w-12 rounded bg-gray-200" />
                      <div className="h-2.5 w-16 rounded bg-gray-200" />
                    </div>
                  </div>
                ))}
              </div>

              {/* Description */}
              <div className="space-y-3 border-b border-gray-200 pb-8">
                <div className="h-4 w-28 rounded bg-gray-200" />
                <div className="h-3 w-full rounded bg-gray-200" />
                <div className="h-3 w-5/6 rounded bg-gray-200" />
              </div>

              {/* Quantity */}
              <div className="space-y-3">
                <div className="h-3 w-20 rounded bg-gray-200" />
                <div className="h-10 w-32 rounded-lg bg-gray-200" />
              </div>

              {/* Actions */}
              <div className="flex gap-2">
                <div className="h-12 w-12 shrink-0 rounded-xl bg-gray-200" />
                <div className="h-12 flex-1 rounded-xl bg-gray-200" />
                <div className="h-12 flex-1 rounded-xl bg-gray-200" />
              </div>

              {/* Profit calculator */}
              <div className="rounded-2xl border border-gray-200 p-5">
                <div className="mb-4 flex items-center gap-2">
                  <div className="h-9 w-9 rounded-full bg-gray-200" />
                  <div className="h-3 w-40 rounded bg-gray-200" />
                </div>
                <div className="flex flex-wrap items-center justify-between gap-4">
                  <div className="flex gap-8">
                    <div className="space-y-2">
                      <div className="h-2 w-16 rounded bg-gray-200" />
                      <div className="h-4 w-20 rounded bg-gray-200" />
                    </div>
                    <div className="space-y-2">
                      <div className="h-2 w-24 rounded bg-gray-200" />
                      <div className="h-4 w-20 rounded bg-gray-200" />
                    </div>
                  </div>
                  <div className="h-20 w-32 rounded-xl bg-gray-200" />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}

  return (
    <div className="min-h-screen bg-gray-50 py-8">
      <div className="mx-auto max-w-8xl px-4 sm:px-6 lg:px-8">
        {/* Breadcrumb */}
        <nav className="mb-6 flex items-center gap-2 text-xs text-gray-500">
          <Link to="/products" className="hover:text-gray-700">{t('navbar.products') || 'Produits'}</Link>
          {product.category?.title && (
            <>
              <ChevronRight size={14} />
              <span>{product.category.title}</span>
            </>
          )}
          <ChevronRight size={14} />
          <span className="text-gray-900 font-medium truncate max-w-xs">{product.name}</span>
        </nav>

        <div className="rounded-2xl bg-white p-6 shadow-sm sm:p-8">
          <div className="grid grid-cols-1 gap-10 lg:grid-cols-2 lg:gap-12">
            {/* ---------------- LEFT: gallery + stats + tabs ---------------- */}
            <div className="space-y-6">
              <div className="lg:hidden">
                <div className="mb-2 flex flex-wrap items-center gap-2">
                  {product.category?.title && (
                    <span className="rounded-full bg-[var(--color-primary-50)] px-3 py-1 text-xs font-medium text-[var(--color-primary-500)]">
                      {product.category.title}
                    </span>
                  )}
                  {product.status === "active" ? (
                    <span className="rounded-full bg-green-100 px-3 py-1 text-xs font-medium text-green-800">
                      {t('products.in_stock')}
                    </span>
                  ) : (
                    <span className="rounded-full bg-red-100 px-3 py-1 text-xs font-medium text-red-800">
                      {t('products.out_of_stock')}
                    </span>
                  )}
                  {product.product_expired_soon === true && (
                    <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-[10px] font-semibold">{t('products.limited_stock')}</span>
                  )}
                </div>

                <h1 className="mt-3 text-3xl font-bold text-gray-900">{product.name}</h1>

                <div className="mt-2 flex flex-wrap items-center gap-2 text-sm">
                  <div className="flex items-center gap-1">
                    {[...Array(5)].map((_, i) => (
                      <span key={i} className={i < Math.round(product.rating || 0) ? 'text-yellow-500 text-lg' : 'text-gray-300 text-lg'}>★</span>
                    ))}
                  </div>
                  <span className="text-gray-600">{product.rating}/5 ({reviewsCount} {t('products.reviews_label') || 'avis'})</span>
                  <span className="text-gray-400">·</span>
                  <span className="text-gray-500">{t('products.product_id')} : {product.id}</span>
                </div>
              </div>
              <ProductImageGallery
                images={[
                  ...(product.image_py ? [{ id: -1, product_id: product.id, image: product.image_py }] : []),
                  ...(product.images || [])
                ]}
                productName={product.name}
                isDiscounted={isDiscounted}
                discountValue={product.discount?.value || 0}
              />

              {/* Stats row */}
              <div className={`grid gap-3 ${stats.length <= 2 ? 'grid-cols-2' : stats.length <= 3 ? 'grid-cols-3' : stats.length <= 4 ? 'grid-cols-2 sm:grid-cols-4' : 'grid-cols-2 sm:grid-cols-3 lg:grid-cols-5'}`}>
                {stats.map(({ icon: Icon, label, value, color }, i) => (
                  <div key={i} className="flex flex-col items-center gap-1.5 rounded-xl border border-gray-100 bg-gray-50/60 dark:bg-stone-900 px-2 py-4 text-center">
                    <div className={`flex h-8 w-8 items-center justify-center rounded-full ${color}`}>
                      <Icon size={18} />
                    </div>
                    <span className="text-sm font-bold text-gray-900">{value}</span>
                    <span className="text-[11px] leading-tight text-gray-500">{label}</span>
                  </div>
                ))}
              </div>

              {/* Tabs */}
              <div>
                <div className="flex gap-6 overflow-x-auto border-b border-gray-200">
                  {tabs.map(tab => (
                    <button
                      key={tab.key}
                      onClick={() => setActiveTab(tab.key)}
                      className={`shrink-0 whitespace-nowrap border-b-2 pb-3 text-sm font-medium transition-colors ${
                        activeTab === tab.key
                          ? 'border-[var(--color-primary-500)] text-[var(--color-primary-500)]'
                          : 'border-transparent text-gray-500 hover:text-gray-700'
                      }`}
                    >
                      {tab.label}
                    </button>
                  ))}
                </div>

                <div className="py-6 text-sm leading-relaxed text-gray-700">
                  {activeTab === 'description' && (
                    product.description
                      ? <div
                          className="rich-description [&_p]:mb-2 [&_ul]:list-disc [&_ul]:pl-5 [&_ol]:list-decimal [&_ol]:pl-5 [&_a]:text-[var(--color-primary-500)] [&_a]:underline [&_h1]:text-lg [&_h1]:font-semibold [&_h2]:text-base [&_h2]:font-semibold [&_h3]:text-sm [&_h3]:font-semibold [&_blockquote]:border-l-3 [&_blockquote]:border-gray-200 [&_blockquote]:pl-3 [&_blockquote]:text-gray-500"
                          dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(product.description) }}
                        />
                      : <p className="text-gray-400">{t('products.no_description') || t('products.not_found')}</p>
                  )}

                  {activeTab === 'specifications' && (
                    product.specifications?.length > 0 ? (
                      <dl className="divide-y divide-gray-100">
                        {product.specifications.map((spec, i) => (
                          <div key={i} className="flex justify-between py-2">
                            <dt className="font-medium text-gray-900">{spec.label}</dt>
                            <dd className="text-gray-600">{spec.value}</dd>
                          </div>
                        ))}
                      </dl>
                    ) : (
                      <p className="text-gray-400">{t('products.no_specifications') || '—'}</p>
                    )
                  )}

                  {activeTab === 'reviews' && (
                    product.reviews?.length > 0 ? (
                      <div className="space-y-4">
                        {product.reviews.map((review, i) => (
                          <div key={i} className="rounded-xl border border-gray-100 p-4">
                            <div className="mb-1 flex items-center gap-1">
                              {[...Array(5)].map((_, s) => (
                                <span key={s} className={s < review.rating ? 'text-yellow-500' : 'text-gray-300'}>★</span>
                              ))}
                            </div>
                            <p className="text-gray-700">{review.comment}</p>
                          </div>
                        ))}
                      </div>
                    ) : (
                      <p className="text-gray-400">{t('products.no_reviews') || '—'}</p>
                    )
                  )}

                  {activeTab === 'shipping' && (
                    <ul className="list-inside list-disc space-y-2">
                      <li>{t('products.shipping_info_1') || 'Livraison estimée sous 24 à 48h partout au Maroc.'}</li>
                      <li>{t('products.shipping_info_2') || 'Paiement à la livraison disponible.'}</li>
                      <li>{t('products.shipping_info_3') || 'Retour accepté sous 7 jours en cas de défaut.'}</li>
                    </ul>
                  )}

                  {activeTab === 'videos' && (
                    product.image_urls ? (
                      <div className="">
                        <h3 className="font-medium text-gray-900 mb-1">{t('products.other_images')} : </h3>
                        <Link
                          to={product.image_urls}
                          target="_blank"
                          rel="noopener noreferrer"
                          className="text-blue-600 underline text-sm"
                        >
                          {product.image_urls}
                        </Link>
                      </div>
                    ) : (
                      <p className="text-gray-400">{t('products.no_videos') || '—'}</p>
                    )
                  )}
                </div>
              </div>
            </div>

            {/* ---------------- RIGHT: info + purchase panel ---------------- */}
            <div className="space-y-6">
              <div className="max-lg:hidden">
                <div className="mb-2 flex flex-wrap items-center gap-2">
                  {product.category?.title && (
                    <span className="rounded-full bg-[var(--color-primary-50)] px-3 py-1 text-xs font-medium text-[var(--color-primary-500)]">
                      {product.category.title}
                    </span>
                  )}
                  {product.status === "active" ? (
                    <span className="rounded-full bg-green-100 px-3 py-1 text-xs font-medium text-green-800">
                      {t('products.in_stock')}
                    </span>
                  ) : (
                    <span className="rounded-full bg-red-100 px-3 py-1 text-xs font-medium text-red-800">
                      {t('products.out_of_stock')}
                    </span>
                  )}
                  {product.product_expired_soon === true && (
                    <span className="bg-blue-100 text-blue-800 px-2 py-1 rounded-full text-[10px] font-semibold">{t('products.limited_stock')}</span>
                  )}
                </div>

                <h1 className="mt-3 text-3xl font-bold text-gray-900">{product.name}</h1>

                <div className="mt-2 flex flex-wrap items-center gap-2 text-sm">
                  <div className="flex items-center gap-1">
                    {[...Array(5)].map((_, i) => (
                      <span key={i} className={i < Math.round(product.rating || 0) ? 'text-yellow-500 text-lg' : 'text-gray-300 text-lg'}>★</span>
                    ))}
                  </div>
                  <span className="text-gray-600">{product.rating}/5 ({reviewsCount} {t('products.reviews_label') || 'avis'})</span>
                  <span className="text-gray-400">·</span>
                  <span className="text-gray-500">{t('products.product_id')} : {product.id}</span>
                </div>
              </div>

              {/* Price / profit card */}
              <div className="rounded-2xl border border-gray-200 p-5 shadow-sm bg-gray-50">
                <div className="flex flex-wrap items-start justify-between gap-4">
                  <div>
                    <p className="text-xs font-medium text-gray-500">{t('products.selling_price_label') || 'Prix de vente'}</p>
                    <div className="mt-1 flex items-center gap-3">
                      <span className="text-2xl font-bold text-green-600">{discountedPrice.toFixed(2)} MAD</span>
                    </div>
                    {isDiscounted && (
                      <div className="mt-1 flex items-center gap-2">
                        <span className="text-sm text-gray-500 line-through">{originalPrice.toFixed(2)} MAD</span>
                        <span className="rounded-lg bg-red-100 px-2 py-0.5 text-xs font-medium text-red-800">
                          -{product.discount.value || 0}% {t('products.off')}
                        </span>
                      </div>
                    )}
                    <p className="mt-2 text-sm text-gray-500">
                      {t('products.recommended_sale') || 'Prix recommandé'} : <span className="font-bold text-gray-700 decoration-gray-400">{recommendedPrice.toFixed(2)} MAD</span>
                    </p>
                    {isDiscounted && product.discount?.date_end && (
                      <p className="mt-2 text-xs text-gray-500">
                        {t('products.offer_valid_until')} {new Date(product.discount.date_end).toLocaleDateString('en-GB')}
                      </p>
                    )}
                  </div>

                  <div className="rounded-xl bg-[var(--color-primary-50)] px-10 py-3 text-right">
                    <p className="text-xs font-medium text-[var(--color-primary-600,var(--color-primary-500))]">{t('products.estimated_profit') || 'Votre profit estimé'}</p>
                    <p className="mt-1 text-xl font-bold text-[var(--color-primary-500)]">+{estimatedProfit.toFixed(2)} MAD</p>
                    <p className="text-xs text-gray-500">{t('products.margin') || 'Marge'} : {estimatedMargin.toFixed(0)}%</p>
                  </div>
                </div>
              </div>

              {/* Info icons row */}
              <div className="grid grid-cols-3 gap-3 border-b border-gray-200 pb-6 sm:grid-cols-3">
                {infoItems.map(({ icon: Icon, label, value }, i) => (
                  <div key={i} className="flex items-center gap-2 border-r">
                    <div className="flex h-9 w-9 shrink-0 items-center justify-center rounded-full bg-gray-100">
                      <Icon size={16} className="text-gray-600" />
                    </div>
                    <div>
                      <p className="text-xs text-gray-500">{label}</p>
                      <p className="text-xs font-semibold text-gray-900">{value}</p>
                    </div>
                  </div>
                ))}
              </div>

              {/* Quantity */}
              <div>
                <label htmlFor="quantity" className="text-sm font-medium text-gray-900 dark:text-white mb-3 block">
                  {t('products.quantity')}
                </label>
                <div className="flex items-center space-x-4">
                  <div className="flex items-center border border-gray-300 rounded-lg">
                    <button
                      onClick={() => setQuantity(prev => Math.max(1, prev - 1))}
                      className="p-2 cursor-pointer hover:bg-gray-100 transition-colors duration-200 rounded-l-lg"
                      disabled={quantity <= 1}
                    >
                      <svg className="h-4 w-4 dark:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M20 12H4" />
                      </svg>
                    </button>
                    <span className="px-4 py-2 dark:text-white text-center min-w-[60px] border-l border-r border-gray-300">
                      {quantity}
                    </span>
                    <button
                      onClick={() => setQuantity(prev => Math.min(product.price.stock, prev + 1))}
                      className="p-2 cursor-pointer hover:bg-gray-100 transition-colors duration-200 rounded-r-lg"
                      disabled={quantity >= (product.price?.stock || 0)}
                    >
                      <svg className="h-4 w-4 dark:text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M12 4v16m8-8H4" />
                      </svg>
                    </button>
                  </div>
                </div>
              </div>

              {/* Variants */}
              {product.variants && product.variants.length > 0 && (
                <div className="pb-2 space-y-4">
                  <h3 className="font-medium text-gray-900">{t('products.select_variants')}</h3>
                  {Array.from({ length: quantity }).map((_, index) => (
                    <div key={index} className="border border-gray-200 rounded-lg px-4 py-2">
                      <h4 className="font-medium mb-1">{t('products.item')} #{index + 1}</h4>
                      <VariantSelector
                        variants={product.variants}
                        onVariantChange={(variants) => handleVariantChange(variants, index)}
                        initialSelectedVariants={selectedVariants[index] || {}}
                        index={index}
                      />
                    </div>
                  ))}
                </div>
              )}

              {/* Actions */}
              <div className="flex max-sm:flex-col gap-2">
                <button
                  onClick={handleToggleWishlist}
                  aria-label={t('products.wishlist') || 'Favoris'}
                  className="flex items-center justify-center rounded-xl border border-gray-300 px-4 py-3 text-gray-500 transition-colors duration-200 hover:bg-gray-50"
                >
                  <Heart size={20} className={isWishlisted ? 'fill-red-500 text-red-500' : ''} />
                </button>

                <button
                  onClick={handleAddToCart}
                  className={`flex flex-1 items-center justify-center gap-2 rounded-xl px-6 py-3 text-sm font-semibold transition-colors duration-200
                    ${isAvailable
                      ? 'bg-[var(--color-primary-500)] text-white hover:bg-[var(--color-primary-400)] cursor-pointer'
                      : 'bg-gray-300 text-white cursor-not-allowed'}`}
                  disabled={!isAvailable}
                >
                  <ShoppingCart size={18} />
                  {t('products.add_to_cart') || 'Ajouter au panier'}
                </button>

                <button
                  onClick={() => setIsModalOpenOrder(true)}
                  className={`flex-1 rounded-xl px-6 py-3 text-sm font-semibold transition-colors duration-200
                    ${isAvailable
                      ? 'bg-gray-900 text-white hover:bg-gray-800 cursor-pointer'
                      : 'bg-gray-300 text-white cursor-not-allowed'}`}
                  disabled={!isAvailable}
                >
                  {isAvailable ? (t('products.order_now') || 'Commander maintenant') : t('products.out_of_stock')}
                </button>
              </div>

              {/* Profit calculator */}
              <ProfitCalculator
                purchasePrice={discountedPrice}
                recommendedPrice={recommendedPrice}
                t={t}
              />

              {/* Supplier / admin-only details */}
              {role === 1 && (
                <div className="space-y-6">
                  <div className="border-t border-gray-200 py-6">
                    <h3 className="text-lg font-medium text-gray-900 mb-4">{t('products.details')}</h3>
                    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm">
                      {product.fournisseur && (
                        <>
                          <div>
                            <span className="font-medium text-gray-900">{t('forms.labels.fournisseur')}:</span>
                            <span className="ml-2 text-gray-700">{product.fournisseur.name}({product.fournisseur.name_personnel})</span>
                          </div>
                          <div>
                            <span className="font-medium text-gray-900">{t('forms.labels.contact_name')}:</span>
                            <span className="ml-2 text-gray-700">{product.fournisseur.phone}</span>
                          </div>
                        </>
                      )}
                      <div>
                        <span className="font-medium text-gray-900">{t('products.purchase_price')}:</span>
                        <span className="ml-2 text-gray-700">{product.price.achat_price} MAD</span>
                      </div>
                      {product.price?.stock !== undefined && (
                        <div>
                          <span className="font-medium text-gray-900">{t('products.stock')}:</span>
                          <span className="ml-2 text-gray-700">{product.price.stock} {t('products.units')}</span>
                        </div>
                      )}
                    </div>
                  </div>

                  {product.sallers && product.sallers.length > 0 && (
                    <div className="border-y border-gray-200 py-6">
                      <h3 className="text-lg font-medium text-gray-900 mb-4">{t('navbar.sellers')} :</h3>
                      <div className="flex flex-wrap items-center gap-3">
                        {product.sallers.map((saller, idx) => (
                          <span
                            key={idx}
                            className="max-w-max flex items-center py-1.5 px-3 rounded-full bg-[var(--color-primary-50)] border-2 border-[var(--color-primary-500)]"
                          >
                            <span className="text-xs font-medium text-[var(--color-primary-500)]">
                              {saller.saller_info?.name} {saller.saller_info?.name_store && `(${saller.saller_info.name_store})`}
                            </span>
                          </span>
                        ))}
                      </div>
                    </div>
                  )}
                </div>
              )}
            </div>
          </div>
        </div>
      </div>

      {isModalOpenOrder &&
        <OrderModal
          isOpen={isModalOpenOrder}
          onClose={() => setIsModalOpenOrder(false)}
          product={product}
        />
      }
    </div>
  );
}

function ProfitCalculator({ purchasePrice, recommendedPrice, t }) {
  const [facebookCost, setFacebookCost] = useState(0);
  const [deliveryCost, setDeliveryCost] = useState(0);
  const [minPrice, setMinPrice] = useState(purchasePrice);
  const [maxPrice, setMaxPrice] = useState(recommendedPrice * 2);
  const [sellingPrice, setSellingPrice] = useState(recommendedPrice);

  const totalCost = purchasePrice + facebookCost + deliveryCost;
  const profit = sellingPrice - totalCost;
  const margin = sellingPrice > 0 ? (profit / sellingPrice) * 100 : 0;

  return (
    <div className="rounded-2xl border border-gray-200 overflow-hidden">
      <div className="bg-gray-50 px-5 py-4">
        <div className="flex items-center gap-2">
          <div className="flex h-8 w-8 items-center justify-center rounded-full bg-[var(--color-primary-100)]">
            <Calculator size={16} className="text-[var(--color-primary-500)]" />
          </div>
          <h3 className="font-semibold text-gray-900">{t('products.calculate_profit') || 'Calculez votre profit'}</h3>
        </div>
      </div>

      <div className="p-5 space-y-5">
        <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1.5">
              {t('products.facebook_cost') || 'Coût Facebook (MAD)'}
            </label>
            <div className="relative">
              <span className="absolute inset-y-0 left-0 pl-3 flex items-center text-gray-400 text-xs">FB</span>
              <input
                type="number"
                min="0"
                step="0.01"
                value={facebookCost || ''}
                onChange={(e) => setFacebookCost(parseFloat(e.target.value) || 0)}
                className="w-full pl-8 pr-3 py-2.5 text-sm border border-gray-200 rounded-xl focus:ring-2 focus:ring-[var(--color-primary-500)] focus:border-transparent outline-none transition-all"
                placeholder="0.00"
              />
            </div>
          </div>
          <div>
            <label className="block text-xs font-medium text-gray-500 mb-1.5">
              {t('products.delivery_cost') || 'Livraison (MAD)'}
            </label>
            <div className="relative">
              <span className="absolute inset-y-0 left-0 pl-3 flex items-center text-gray-400 text-xs">
                <Truck className='w-3.5 h-3.5' />
              </span>
              <input
                type="number"
                min="0"
                step="0.01"
                value={deliveryCost || ''}
                onChange={(e) => setDeliveryCost(parseFloat(e.target.value) || 0)}
                className="w-full pl-8 pr-3 py-2.5 text-sm border border-gray-200 rounded-xl focus:ring-2 focus:ring-[var(--color-primary-500)] focus:border-transparent outline-none transition-all"
                placeholder="0.00"
              />
            </div>
          </div>
        </div>

        <div className="bg-gray-50 rounded-xl p-4 space-y-3">
          <div className="flex items-center justify-between">
            <span className="text-xs font-medium text-gray-500">
              {t('products.price_range') || 'Fourchette de prix'}
            </span>
            <span className="text-xs text-gray-400">
              {minPrice.toFixed(0)} MAD — {maxPrice.toFixed(0)} MAD
            </span>
          </div>
          <div className="flex items-center gap-3">
            <span className="text-xs font-semibold text-gray-600 w-12">{minPrice.toFixed(0)}</span>
            <input
              type="range"
              min={minPrice}
              max={maxPrice}
              step="0.5"
              value={sellingPrice}
              onChange={(e) => setSellingPrice(parseFloat(e.target.value))}
              className="flex-1 h-2 rounded-full appearance-none cursor-pointer bg-gray-200 accent-[var(--color-primary-500)]"
            />
            <span className="text-xs font-semibold text-gray-600 w-12 text-right">{maxPrice.toFixed(0)}</span>
          </div>
          <div className="text-center">
            <span className="text-[10px] text-gray-400">{t('products.selling_price') || 'Prix de vente'}</span>
            <p className="text-lg font-bold text-gray-900">{sellingPrice.toFixed(2)} MAD</p>
          </div>
        </div>

        <div className="border-t border-gray-100 pt-4 space-y-2.5">
          <div className="flex justify-between text-xs text-gray-500">
            <span>{t('products.purchase_price') || "Prix d'achat"}</span>
            <span className="font-medium text-gray-700">{purchasePrice.toFixed(2)} MAD</span>
          </div>
          <div className="flex justify-between text-xs text-gray-500">
            <span>{t('products.facebook_cost') || 'Coût Facebook'}</span>
            <span className="font-medium text-gray-700">+ {facebookCost.toFixed(2)} MAD</span>
          </div>
          <div className="flex justify-between text-xs text-gray-500">
            <span>{t('products.delivery_cost') || 'Livraison'}</span>
            <span className="font-medium text-gray-700">+ {deliveryCost.toFixed(2)} MAD</span>
          </div>
          <div className="border-t border-dashed border-gray-200 pt-2.5 flex justify-between text-sm font-semibold text-gray-700">
            <span>{t('products.total_cost') || 'Coût total'}</span>
            <span>{totalCost.toFixed(2)} MAD</span>
          </div>
        </div>

        <div className={`rounded-xl p-4 text-center ${profit > 0 ? 'bg-green-50 border border-green-200' : profit < 0 ? 'bg-red-50 border border-red-200' : 'bg-gray-50 border border-gray-200'}`}>
          <p className="text-xs text-gray-500 mb-1">{t('products.estimated_profit') || 'Profit estimé'}</p>
          <p className={`text-2xl font-bold ${profit > 0 ? 'text-green-600' : profit < 0 ? 'text-red-600' : 'text-gray-600'}`}>
            {profit >= 0 ? '+' : ''}{profit.toFixed(2)} MAD
          </p>
          <div className="mt-1 flex items-center justify-center gap-1">
            <div className={`h-1.5 w-24 rounded-full ${profit > 0 ? 'bg-green-200' : 'bg-red-200'}`}>
              <div
                className={`h-1.5 rounded-full transition-all ${profit > 0 ? 'bg-green-500' : 'bg-red-500'}`}
                style={{ width: `${Math.min(Math.abs(margin), 100)}%` }}
              />
            </div>
            <span className={`text-xs font-medium ${profit > 0 ? 'text-green-600' : profit < 0 ? 'text-red-600' : 'text-gray-500'}`}>
              {margin.toFixed(1)}%
            </span>
          </div>
        </div>
      </div>
    </div>
  );
}
